import { FC, createElement, useEffect, useRef, ReactHTML } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { extractAnchor } from 'helpers/pageHelpers'
import { State } from 'interfaces/state'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { QAMarked } from 'interfaces/component'

const EMPTY_ANCHOR = {
  current: null,
  options: null,
}

type PageAnchorHandlerProps =
  & QAMarked
  & {
    component?: keyof ReactHTML
    placement: NonNullable<State['app']['navigation']['activeAnchor']>['current']
    className?: string
  }

export const PageAnchorHandler: FC<PageAnchorHandlerProps> = (props) => {
  const {
    children,
    className,
    component = 'div',
    placement,
    qaType,
    qaMarker,
  } = props

  const dispatch = useStoreDispatch()
  const activeAnchor = useStoreSelector((state) => state.app.navigation.activeAnchor || EMPTY_ANCHOR)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const { current } = ref
    if (!activeAnchor || !activeAnchor.current || extractAnchor(activeAnchor.current) !== extractAnchor(placement) || !current) {
      return
    }

    const { behavior, block } = activeAnchor.options

    current.scrollIntoView({
      behavior: behavior === 'smooth' ? 'smooth' : 'auto',
      block,
    })

    dispatch(activateAnchorActionCreator(null))
  }, [activeAnchor, placement, dispatch])

  const elementProps = {
    ref,
    className,
    'data-anchor': placement,
    'data-qa-type': qaType,
    'data-qa-marker': qaMarker,
  }

  return createElement(component, elementProps, children)
}
